import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@devhop/ui";
import { PackageIcon } from "lucide-react";

export type CampSellPackageOption = {
  templateId: string;
  templateName: string;
  totalSessions: number;
  validDays: number;
  selectedRuleIds: string[];
  classTypeNames: string[];
};

type CampPackagePickerDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  templates: CampSellPackageOption[];
  onSelect: (templateId: string) => void;
};

export function CampPackagePickerDialog({
  open,
  onOpenChange,
  templates,
  onSelect,
}: CampPackagePickerDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <PackageIcon className="size-5" />
            ເລືອກແພັກເກດ Camp
          </DialogTitle>
          <DialogDescription>
            ມີຫຼາຍແພັກເກດທີ່ຜູກໄວ້ — ເລືອກອັນທີ່ຈະຂາຍໃຫ້ນັກຮຽນຄົນນີ້
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {templates.map((item) => (
            <Button
              key={item.templateId}
              type="button"
              variant="outline"
              className="h-auto w-full flex-col items-start gap-1 px-4 py-3 text-left"
              onClick={() => {
                onSelect(item.templateId);
                onOpenChange(false);
              }}
            >
              <span className="font-semibold">{item.templateName}</span>
              <span className="text-muted-foreground text-xs">
                {item.totalSessions} ຄັ້ງ · {item.validDays} ວັນ
                {item.classTypeNames.length > 0
                  ? ` · ${item.classTypeNames.join(", ")}`
                  : ""}
              </span>
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
